import { Injectable } from '@angular/core';
import { RouteData, RouterState } from '@frontend-site/shared/router-store';
import { Router } from '@angular/router';
import { MenuItem, MenuStore } from '@frontend-site/main-header/domain';

@Injectable({
    providedIn: 'root'
})
export class MenuItemHighlightService {
    constructor(public readonly router: Router, private readonly store: MenuStore) {}

    isHighlighted(routerState: RouterState, menuItem: MenuItem, isCurrentlyHighlighted: boolean): boolean {
        return this.isKeepCurrentHighlightState(routerState.data)
            ? isCurrentlyHighlighted
            : this.shouldBeDisplayedAsActive(menuItem.routePath) ||
                  this.getIsMenuOrSubMenuActive(menuItem) ||
                  this.isActiveByExtraDefinition(menuItem, routerState.data);
    }

    public isActiveByExtraDefinition(menuItem: MenuItem, routeData?: RouteData): boolean {
        const navMenuHighlight = routeData?.navMenuHighlight;

        if (!navMenuHighlight || !navMenuHighlight.navMenuItemHighlightFunction) {
            return false;
        }

        return navMenuHighlight.navMenuItemHighlightFunction(this.store.getCurrentMenuEntries(), menuItem.id ?? '');
    }

    private getIsMenuOrSubMenuActive(menuItem: MenuItem): boolean {
        let isActive = this.router.isActive(menuItem.routePath, {
            paths: 'subset',
            queryParams: 'subset',
            fragment: 'ignored',
            matrixParams: 'ignored'
        });

        menuItem.menu?.forEach((submenu) => {
            isActive = isActive || this.getIsMenuOrSubMenuActive(submenu);
        });
        return isActive;
    }

    private shouldBeDisplayedAsActive(menuItemPath: string): boolean {
        return menuItemPath.includes('/discovery') && this.router.url.includes('/free-text-search');
    }

    private isKeepCurrentHighlightState(routeData?: RouteData): boolean {
        return routeData?.navMenuHighlight?.keepPreviousHighlightState || false;
    }
}
